export default __webpack_public_path__ + "static/GothamBook-e33c0037cc9bf742d34a2de8dd73eb0e.eot";